// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"styles_Avatar__3VKst"};